import { Env } from "../../../index";
import { ClientsCatalog } from "../../classes/client/Client";
import c001Client from "./prod/c001";
import c002Client from "./prod/c002";

const prodClients = new ClientsCatalog({
	clients: [c001Client, c002Client],
});

const clients = (env: Env) => {
	switch (env) {
		case Env.STAGE:
			return prodClients;
		default:
			return prodClients;
	}
};

export { clients };
